// Change the file names here if your PNGs are named differently
const ICONS = {
    halal: "/halal.png",
    alcohol: "/alcohol.png",
    veg: "/veg.png",
    non_veg: "/non_veg.png",
};

const FOOD_TYPE_LABEL = {
    veg: "Veg",
    non_veg: "Non-Veg",
    both: "Veg & Non-Veg",
};

const Tag = ({ icons, label }) => (
    <span
        title={label}
        className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-gray-50 border border-gray-200 text-[11px] text-gray-600"
    >
        {icons.map((src) => (
            <img key={src} src={src} alt="" className="w-4 h-4 object-contain" />
        ))}
        {label}
    </span>
);

export default function StoreTags({ store, className = "" }) {
    const { is_halal, food_type, alcohol_allowed } = store;

    const foodIcons =
        food_type === "both"
            ? [ICONS.veg, ICONS.non_veg]
            : food_type === "veg" || food_type === "non_veg"
            ? [ICONS[food_type]]
            : [];

    if (!is_halal && !alcohol_allowed && !foodIcons.length) return null;

    return (
        <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
            {foodIcons.length > 0 && (
                <Tag icons={foodIcons} label={FOOD_TYPE_LABEL[food_type]} />
            )}
            {is_halal && <Tag icons={[ICONS.halal]} label="Halal" />}
            {alcohol_allowed && <Tag icons={[ICONS.alcohol]} label="Alcohol" />}
        </div>
    );
}